import React from 'react';

// Components
import classnames from 'classnames';

import SubscriberNewsletter from '@common/components/Forms/Newsletter/Newsletter';

// Styles

import styles from './NewsletterComponent.module.scss';

class NewsletterComponent extends React.Component {
  render() {
    const { className, data } = this.props;

    return (
      <div className={classnames(styles.newsletter, className)} id="newsletter">
        <h2 className={styles.heading}>{data.heading}</h2>
        <div className={styles.body}>
          <SubscriberNewsletter />
        </div>
      </div>
    );
  }
}

export default NewsletterComponent;
